import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../../internal/Action.js";
import { Qualifier } from "../../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../../internal/qualifier/QualifierValue.js";
/**
 * @description Changes the speed of the video playback using the rate() method
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var AccelerationEffectAction = /*#__PURE__*/function (_Action) {
  _inherits(AccelerationEffectAction, _Action);

  var _super = _createSuper(AccelerationEffectAction);

  function AccelerationEffectAction(rate) {
    var _this;

    _classCallCheck(this, AccelerationEffectAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'accelerate'
    };
    rate && _this.rate(rate);
    return _this;
  }

  _createClass(AccelerationEffectAction, [{
    key: "rate",
    value: function rate(_rate) {
      this._actionModel.rate = _rate;
      this._rate = _rate;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue = new QualifierValue(['accelerate', this._rate]).setDelimiter(':');
      this.addQualifier(new Qualifier('e', qualifierValue));
      return this;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var rate = actionModel.rate; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created
      // @ts-ignore

      var result = new this();
      rate && result.rate(rate);
      return result;
    }
  }]);

  return AccelerationEffectAction;
}(Action);

export { AccelerationEffectAction };